const style = `.pre-angular-root-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.pre-angular-root-container img {
  height: 24px;
}

.pre-angular-root-container .wait-message {
  display: block;
  margin: 25px;
  text-align: center;
  color: lightgray;
}

.pre-angular-root-container .error-message {
  color: red;
}

.pre-angular-root-container .spinner {
  margin: 15px auto;
  width: 70px;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}

.pre-angular-root-container .spinner > div {
  width: 10px;
  height: 10px;
  background-color: #003eab;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.pre-angular-root-container .spinner > div:first-child {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.pre-angular-root-container .spinner > div:nth-child(2) {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}`;

const html = `<div class="pre-angular-root-container">
  <img id="logo" />
  <span class="wait-message">Initializing</span>
  <div class="spinner">
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>`;

export function initView(selector: string, logoSrc?: string): void {
  const el = document.querySelector(selector);
  const queryParams = location.search;
  if (el) {
    el.innerHTML = `
<style>
  ${style}
</style>
${html}
`;

    if (logoSrc) {
      el.querySelector('#logo').setAttribute('src', logoSrc);
    }
  } else {
    throw new Error('Invalid pre angular view selector: ' + selector);
  }
}

export function setInitLogo(selector: string, logoSrc: string): void {
  const el = document.querySelector(selector);
  el.querySelector('#logo').setAttribute('src', logoSrc);
}

/**
 * Removes some of the content used in the pre angular view.
 * Once disposed it can not revert.
 */
export function disposeView(): void {}

/**
 * Updates the message displayed to the user in the application load page.
 */
export function updateMessage(msg: string): void {
  if (document) {
    const el = document.querySelector('.pre-angular-root-container .wait-message');
    if (el) {
      // Use textContent instead of innerHTML to prevent XSS vulnerabilities
      el.textContent = msg;
    }
  }
}

export function displayError(errorMsg: string): void {
  if (document) {
    const elSpinner: HTMLElement = <any>document.querySelector('.pre-angular-root-container .spinner');
    if (elSpinner) {
      elSpinner.style.display = 'none';
    }

    const elMsg: HTMLElement = <any>document.querySelector('.pre-angular-root-container .wait-message');
    if (elMsg) {
      elMsg.classList.add('error-message');
      updateMessage(errorMsg);
    }
  }
}
